import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

import { statesMap } from '../../helpers/states';

const State = ({onChange}) => {
    const defaultState = Array.from(statesMap).find(state => state[0] === 'AGREED')

    return (
        <Select
            size={'large'}
            placeholder={'Կարգավիճակ'}
            style={{ width: '100%' }}
            defaultValue={defaultState[0]}
            onChange={onChange}
            mode="multiple"
        >
            {Array.from(statesMap).map(state => (
                <Select.Option
                    key={state[0]}
                    value={state[0]}
                >
                    {state[1]}
                </Select.Option>
            ))}
        </Select>
    )
};

State.propTypes = {
    onChange: PropTypes.func.isRequired,
};

export default State;